
export default function Footer() {
  return (
    <footer className="bg-[#0F1C2E] pt-16 pb-10">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10 mb-14">
          <div className="col-span-1 md:col-span-2">
            <img
              src="https://static.readdy.ai/image/0fc33fa68f46f743570ad8ba1c3172ea/b159d9a361187084121e81321b9594ff.png"
              alt="AI Business Partners"
              className="h-24 w-auto mb-5"
            />
            <p className="text-sm text-[#F5F7FA]/50 max-w-sm leading-relaxed">
              Strategic AI consulting for organizations that demand measurable results, operational excellence, and disciplined execution.
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-[#C9CDD3] mb-5 uppercase tracking-wider">
              <a href="#approach" className="hover:text-[#F5F7FA] transition-colors cursor-pointer">Services</a>
            </h4>
            <ul className="space-y-3">
              <li>
                <a href="#approach" className="text-sm text-[#F5F7FA]/50 hover:text-[#F5F7FA] transition-colors cursor-pointer">
                  AI Audit
                </a>
              </li>
              <li>
                <a href="#approach" className="text-sm text-[#F5F7FA]/50 hover:text-[#F5F7FA] transition-colors cursor-pointer">
                  Strategic Roadmap
                </a>
              </li>
              <li>
                <a href="#approach" className="text-sm text-[#F5F7FA]/50 hover:text-[#F5F7FA] transition-colors cursor-pointer">
                  Precision Execution
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-[#C9CDD3] mb-5 uppercase tracking-wider">
              <a href="#who-we-work-with" className="hover:text-[#F5F7FA] transition-colors cursor-pointer">Company</a>
            </h4>
            <ul className="space-y-3">
              <li>
                <a href="#who-we-work-with" className="text-sm text-[#F5F7FA]/50 hover:text-[#F5F7FA] transition-colors cursor-pointer">
                  Who We Work With
                </a>
              </li>
              <li>
                <a href="#outcomes" className="text-sm text-[#F5F7FA]/50 hover:text-[#F5F7FA] transition-colors cursor-pointer">
                  Outcomes
                </a>
              </li>
              <li>
                <a href="#consultation" className="text-sm text-[#F5F7FA]/50 hover:text-[#F5F7FA] transition-colors cursor-pointer">
                  Contact
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-[#F5F7FA]/10 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p className="text-xs text-[#F5F7FA]/30 mb-4 md:mb-0">
              © 2025 AI Business Partners. All rights reserved.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}
